import { Module } from '@nestjs/common';

import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApaMatrixRepository } from './repo/apa-matrix-repo';
import { ApaSizeMatrixEntity } from './entity/apa-matrix.entity';
import { ApaSizeMatrixService } from './apa-size-matrix.service';
import { ApaSizeMatrixController } from './apa-size-matrix.controller';
import { PPMDataRepository } from '../dpom/repositories/ppm-data.repository';
import { APaSizeMatrixAdapter } from './adapters/apa-size-matrix.adapter';
import { StyleRepo } from '../po-bom/dto/style-repo';
import { StyleEntity } from '../po-bom/entittes/style-entity';


@Module({
  providers: [ApaSizeMatrixService, ApplicationExceptionHandler, ApaMatrixRepository, PPMDataRepository, APaSizeMatrixAdapter, StyleRepo],
  imports: [
    TypeOrmModule.forFeature([ApaSizeMatrixEntity,StyleEntity])],
  controllers: [ApaSizeMatrixController],
  exports: [ApaSizeMatrixService]
})
export class ApaMatrixModule { }